import {useTranslation} from "react-i18next";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import DateDisplay from "components/datetime/DateDisplay";
import DateTimesUtils from "core/utils/DateTimesUtils";

const TableProgTasks = ({
    itemsShow,
    items,
    checkAll,
    setCheckAll,
    buttonsTB,
    setButtonsTB,
    orderingRef,
}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Td} = useTranslation("datestimes");
    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }
        const taskId = Number(e.currentTarget.dataset.idx);

        if (checkbox.checked) {
            items.current.addToChosen(taskId);
        } else {
            items.current.removeFromChosen(taskId);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => Number(item.id));
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    const translateValues = (item) => {
        let title = "";
        const repeat = item.repeat;
        const values = item.values || {};
        switch (repeat) {
            case "w":
                if (Array.isArray(values.days)) {
                    const days = values.days.map((d) => _Td("days." + d));
                    title = days.join(", ");
                }
                break;
            case "m":
                switch (values.type) {
                    case "d":
                        title = "Dia " + values.day + " de cada mes";
                        break;
                    case "n":
                        title = _Td("the_place." + values.value) + " " + _Td("days_name." + values.day) + " de cada mes";
                        break;
                    case "p":
                        title = _Td("the_place." + values.value) + " " + _Td("days_name." + values.day) + " de cada mes";
                        break;
                    default:
                }
                break;
            case "y":
                switch (values.type) {
                    case "d":
                        title = "Dia " + values.day + " de " + _Td("months_name." + values.value);
                        break;
                    case "n":
                        title = _Td("the_place." + values.place) + " " + _Td("days_name." + values.day) + " de " + _Td("months_name." + values.value);
                        break;
                    case "p":
                        title = _Td("the_place." + values.place) + " " + _Td("days_name." + values.day) + " de " + _Td("months_name." + values.value);
                        break;
                    default:
                }
                break;
            default:
                break;
        }
        return title;
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th style={{...stickyHeaderStyle}} key="-1">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onClick={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxTask"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={Array.isArray(items.current.chosen) ? items.current.chosen.includes(item.id) : false}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <td>{item.date_start ? <DateDisplay date={item.date_start} format="DD-MM-YYYY" title={true} /> : "-"}</td>
                            <td>{item.date_end ? <DateDisplay date={item.date_end} format="DD-MM-YYYY" title={true} /> : "-"}</td>
                            <td>{item.compile ? DateTimesUtils.timeToHourMinute(item.compile) : "-"}</td>
                            <td>{item.run ? DateTimesUtils.timeToHourMinute(item.run) : "-"}</td>
                            <td>{_Tc("repeat." + item.repeat) || item.repeat}</td>
                            <td>{translateValues(item)}</td>

                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={12}></td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default TableProgTasks;
